namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	import ISoundManager = Roodik.Core.ISoundManager;
	import Easing = Roodik.Core.Tween.Easing;
	import Tween = Roodik.Core.Tween.Tween;
	import Point = PIXI.Point;
	import LocalizationManager = Roodik.Core.LocalizationManager;

	export class MenuView extends ViewBase
	{
		private _message : PIXI.Text;
		private _closeButton : SimpleButton;
		private _btnSound : CheckBoxButton;
		private _btnMusic : CheckBoxButton;
		private _closePanel:()=>void;

		constructor(private _localizationManager:LocalizationManager,
		            private _soundManager:ISoundManager, closeCallBack:()=>void)
		{
			super("MenuPanel");
			this.alpha = 0;
			this.y = 300;

			this._closePanel = () => {
				closeCallBack();
			};

			this._message = new PIXI.Text(this._localizationManager.getString(LocalizationKey.MENU_TITLE),
			{
				fontFamily: 'WellWait',
				fontSize: 70,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: ['#FFA500', '#FFD700'],//'#FFD700',//['#FFD700', '#4a1850'], // gradient
				stroke: '#ffffff',//'#338d13',
				strokeThickness: 5,

				dropShadow: true,
				dropShadowColor: '#ffffff',
				dropShadowBlur: 1,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			});
			this._message.x = -this._message.width*0.5;
			this._message.y = -290;
			this.addChild(this._message);

			this._btnSound = new CheckBoxButton(this.childByName("SoundBtn").display, "noiseoff",
			this._soundManager.soundIsOn,
			this._localizationManager.getString(LocalizationKey.MENU_SOUND), {
				fontFamily: 'WellWait',
				fontSize: 22,
				fill: '#FFDEAD',//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 1,
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,
				padding:20
			}, new Point(-1,0));
			this._btnSound.textPosition = new PIXI.Point(-30,0);

			this._btnMusic = new CheckBoxButton(this.childByName("MusicBtn").display, "noiseoff", this._soundManager.musicIsOn,
			this._localizationManager.getString(LocalizationKey.MENU_MUSIC), {
				fontFamily: 'WellWait',
				fontSize: 22,
				fill: '#FFDEAD',//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 1,
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,
				padding:20
			}, new Point(-1,0));
			this._btnMusic.textPosition = new PIXI.Point(-30,0);

			this._btnSound.events.on(SimpleButton.CLICKED, this.onClickSoundBtn.bind(this));
			this._btnMusic.events.on(SimpleButton.CLICKED, this.onClickMusicBtn.bind(this));

			this._closeButton = new SimpleButton(this.childByName("CloseButton").display,
			this._localizationManager.getString(LocalizationKey.BUTTON_OK), {
				fontFamily: 'WellWait',
				fontSize: 32,
				fill: '#FFDEAD',//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 1,
				align:"center",
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			});
			this._closeButton.events.on(SimpleButton.CLICKED, this.hide.bind(this));

			this.show();
		}

		private onClickSoundBtn()
		{
			this._soundManager.playSound("click.mp3", 1);
			this._soundManager.soundIsOn ? this._soundManager.muteSound() : this._soundManager.unMuteSound();
		}
		private onClickMusicBtn()
		{
			this._soundManager.playSound("click.mp3", 1);
			this._soundManager.musicIsOn ? this._soundManager.muteMusic() : this._soundManager.unMuteMusic();
		}

		private show()
		{
			let properties = {alpha:this.alpha, y:this.y};
			new Tween(properties)
			.to({alpha: 1, y: 0}, 150)
			.easing(Easing.Quadratic.In)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.start();
		}

		private hide()
		{
			this._soundManager.playSound("click.mp3", 1);

			let properties = {alpha:this.alpha,y:this.y};
			new Tween(properties)
			.to({alpha: 0, y: -300}, 150)
			.easing(Easing.Quadratic.Out)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.onComplete(function ()
			{
				this._closePanel();
			}.bind(this))
			.start();
		}

		public destroy()
		{
			this.removeChild(this._message);
			this._message.destroy();

			this._btnSound.events.off(SimpleButton.CLICKED, this.onClickSoundBtn.bind(this));
			this._btnMusic.events.off(SimpleButton.CLICKED, this.onClickMusicBtn.bind(this));
			this._btnSound.destroy();
			this._btnMusic.destroy();

			this._closeButton.events.off(SimpleButton.CLICKED, this.hide.bind(this));
			this._closeButton.destroy();

			this._closePanel = null;

			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/MenuView.ts